const SCROLL_OFFSET = 70

export function scrollToSection(id: string, offset = SCROLL_OFFSET) {
  const el = document.getElementById(id)
  if (!el) return
  const top = el.getBoundingClientRect().top + window.scrollY - offset
  window.scrollTo({ top, behavior: 'smooth' })
}
